module.exports = __webpack_public_path__ + "static/media/floorless-tent.884482a5.svg";